import type { FormEvent } from 'react';
import { useState } from 'react';

import {
  Alert,
  FormGroup,
  FormLabel,
} from '@admin-platform/ui/components';

import { Input } from '../../components/Inputs/Input';
import RevvlyMark from '../../components/Layout/revvly-mark.svg?react';
import { Link } from 'react-router-dom';

import styles from './ForgotPassword.module.css';

// `??` so an intentionally-empty VITE_API_ENDPOINT (staging/preview, worker
// proxies API same-origin) stays "" → relative URLs, not localhost.
const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT ?? 'http://localhost:4200';
const FRONTEND_URL = window.location.origin;

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      await fetch(`${API_BASE_URL}/api/auth/request-password-reset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, redirectTo: `${FRONTEND_URL}/reset-password` }),
      });
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <RevvlyMark className={styles.mark} aria-hidden="true" />
        <h1 className={styles.logo}>Revvly</h1>
        <p className={styles.subtitle}>Reset your password</p>

        {!submitted ? (
          <form className={styles.form} onSubmit={handleSubmit}>
            <FormGroup>
              <FormLabel htmlFor="forgot-email">Email</FormLabel>
              <Input
                id="forgot-email"
                type="email"
                placeholder="you@company.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
            </FormGroup>

            <button className={styles.submitButton} type="submit" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Send reset link'}
            </button>
          </form>
        ) : (
          <Alert type="success" className={styles.alertBlock}>
            If an account exists for that email, you'll receive a reset link shortly.
          </Alert>
        )}

        <Link className={styles.backLink} to="/login">
          Back to login
        </Link>
      </div>
    </div>
  );
}
